if (!customElements.get('free-product')) {
  customElements.define(
    'free-product',
    class FreeProduct extends HTMLElement {
      constructor() {
        super();

        this.variantId = this.getAttribute('data-variant-id');
        this.threshold = (parseFloat(this.getAttribute('data-threshold') || '49') || 0) * 100;
        // Same employee check the rest of the theme uses (js-variables / theme.liquid),
        // so the cable is never added for employees even if the attribute is stale.
        this.customerExcluded = this.getAttribute('data-customer-excluded') === 'true'
          || Boolean(window.theme && theme.customer && theme.customer.isEmployee)
          || document.body.hasAttribute('data-employee-customer');
        this.busy = false;
        this.disabled = false;
        this.cartUpdateUnsubscriber = null;

        this.handleCartUpdate = this.handleCartUpdate.bind(this);
      }

      connectedCallback() {
        if (this.cartUpdateUnsubscriber) return;

        this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
        this.check();
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = null;
        }
      }

      handleCartUpdate(event) {
        this.check(event && event.cart);
      }

      async check(cart) {
        if (this.busy || this.disabled) return;
        if (window.Shopify && Shopify.designMode) return;

        const target = String(this.variantId || '');
        if (!target) return;

        if (!cart || !cart.items) {
          try {
            const response = await fetch(theme.routes.cart_url, {...theme.utils.fetchConfig('json', 'GET')});
            cart = await response.json();
          }
          catch (error) {
            return;
          }
        }

        let eligibleSubtotal = 0;
        const freeLines = [];
        for (const item of cart.items) {
          if (String(item.variant_id) === target) {
            freeLines.push(item);
            continue;
          }
          eligibleSubtotal += (item.final_line_price || (item.price * item.quantity) || 0);
        }

        const freeQuantity = freeLines.reduce((total, item) => total + (item.quantity || 0), 0);

        if (this.customerExcluded) {
          if (freeLines.length > 0) {
            const updates = {};
            freeLines.forEach((item) => {
              updates[item.key] = 0;
            });
            this.updateFreeProduct(updates);
          }

          return;
        }

        if (eligibleSubtotal >= this.threshold) {
          if (freeLines.length === 0) {
            this.addFreeProduct(target);
          }
          else if (freeQuantity > 1 || freeLines.length > 1) {
            // Free product is limited to 1 per order. Collapse any extra quantity or
            // duplicate (split) lines back to a single line with quantity 1 (QA #1).
            const updates = {};
            freeLines.forEach((item, index) => {
              updates[item.key] = index === 0 ? 1 : 0;
            });
            this.updateFreeProduct(updates);
          }
        }
        else if (freeLines.length > 0) {
          const updates = {};
          freeLines.forEach((item) => {
            updates[item.key] = 0;
          });
          this.updateFreeProduct(updates);
        }
      }

      updateFreeProduct(updates) {
        this.busy = true;

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.disabled = true;
              return;
            }

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-product', cart: parsedState });
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.busy = false;
          });
      }

      addFreeProduct(variantId) {
        this.busy = true;

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.disabled = true;
              return;
            }

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
            cartJson['sections'] = parsedState['sections'];
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-product', cart: cartJson });
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.busy = false;
          });
      }
    }
  );
}
